import * as React from 'react';
import { Table } from 'react-bootstrap';
import { ResourceAction } from 'app/redux/Resources/actions';

interface IFoundationMarkIndexTableProps {
  monthNumber?: string;
}

export class FoundationMarkIndexTable extends React.Component<IFoundationMarkIndexTableProps, {}> {
  private static baseFileNamePrefix = 'FoundationMark Fiscal ';
  private static baseFileNameSuffix = ' Index.pdf';
  state = {
    indicies: [],
  };

  componentWillMount() {}

  componentDidMount() {
    this.getIndicesData(this.props.monthNumber);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.monthNumber !== this.props.monthNumber) {
      this.setState({ monthNumber: this.props.monthNumber }, () => {
        this.getIndicesData(this.props.monthNumber);
      });
    }
  }

  getIndicesData(monthNumber?: string) {
    const month = monthNumber || '12';
    const tableFilterBody = {
      action: 'getFoundationMarkIndexTable',
      request: { assetLevel: 0, name: '', monthNumber: month, dateStart: '', dateEnd: '' },
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(tableFilterBody),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        this.setState({ indicies: json });
      });
  }

  roundToTenths(number: number) {
    return number.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  }

  renderTableHeader() {
    return (
      <tr>
        <th>Index</th>
        <th>1 Year</th>
        <th>3 Year</th>
        <th>5 Year</th>
      </tr>
    );
  }

  renderTableRow(row, index) {
    return (
      row.index == 'fmEnabled' && (
        <tr key={row.index + index}>
          <td>{row.name}</td>
          <td>{this.roundToTenths(row.year)}%</td>
          <td>{this.roundToTenths(row.threeYear)}%</td>
          <td>{this.roundToTenths(row.fiveYear)}%</td>
        </tr>
      )
    );
  }

  render() {
    return (
      <Table>
        <thead>{this.renderTableHeader()}</thead>
        <tbody>
          {this.state.indicies &&
            this.state.indicies.map((indexData, index) => {
              return this.renderTableRow(indexData, index);
            })}
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/FoundationMarkIndex/Table/index.tsx